import React from 'react';
import { Icon, Button } from '@scuf/common';
import '../GenericPage/GenericPage.scss';
import { useAuthService } from '../../auth/hooks/useAuthService';

export default function LoginFailurePage({
  message,
  buttonContent
}: {
  message: string;
  buttonContent?: string;
}) {
  const { signIn } = useAuthService();
  return (
    <div className="un-authorized-container">
      <div className="un-authorized">
        <Icon name="badge-warning" size="xlarge" />
        <h1 id="headerPageNotFound">{message}</h1>
        <Button
          className="routeToHomeButton"
          onClick={() => signIn()}
          type="secondary"
          content={buttonContent}
        />
      </div>
    </div>
  );
}
